import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'

import {
  BatchOrderAcceptLedgerPageLoadResult,
  BatchOrderAcceptPageLoadResultFromJSON
} from '@/api/models/batch/BatchOrderAcceptLedgerPageLoadResult'
import {
  BatchOrderAcceptLedgerRequest,
  BatchOrderAcceptLedgerRequestToJSON
} from '@/api/models/batch/BatchOrderAcceptLedgerRequest'

export class BatchOrderAcceptLedgerApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchOrderAcceptLedgerPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchOrderAcceptPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createOrderAccept(
    request: BatchOrderAcceptLedgerRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/order-accept/ledger`,
      BatchOrderAcceptLedgerRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
